import React, { Fragment, useState } from 'react';
import T from 'prop-types';

import FormModal from './FormModal';
import Button from '../../../../../components/Buttons/Button';

const AdditionalAppInsights = ({
  formId,
  portalId,
  buttons = [],
}) => {
  const [isOpen, setModalOpen] = useState(false);

  return (
    <Fragment>
      <div className="additional-app-insights">
        <h4>Additional app insights</h4>
        <div className="btns">
          {buttons.map(button => (
            <Button
              size="lg"
              onClick={() => setModalOpen(true)}
            >
              {button}
            </Button>
          ))}
        </div>
      </div>
      <FormModal
        open={isOpen}
        formId={formId}
        portalId={portalId}
        onModalClose={() => setModalOpen(false)}
      />
    </Fragment>
  );
};

AdditionalAppInsights.propTypes = {
  formId: T.oneOfType([T.string, T.number]).isRequired,
  portalId: T.oneOfType([T.string, T.number]).isRequired,
  buttons: T.arrayOf([T.string]),
};

export default AdditionalAppInsights;
